function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconTimeCheckInFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 28h13V4H9v9H7V4a2 2 0 012-2h13a2 2 0 012 2v24a2 2 0 01-2 2H9a2 2 0 01-2-2v-9h2v9z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 16l-7-5v4H2v2h9v4l7-5z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 28h26v2H4v-2z",
    fill: props.color
  }));
}

export default SvgIconTimeCheckInFilled;